<script lang="ts">
	import { appStore } from '../../stores/appStore';
	import { fade } from 'svelte/transition';
	import { getContext } from 'svelte';

	export let text: string;
	const onlyText = !$$props.$$scope.ctx[1];
	type RenderedText = {
		id: number;
		text: string;
	};
	let renderedTextArray: RenderedText[] = [];
	const messageId: string = getContext('messageId');
	$: {
		setTimeout(() => {
			renderedTextArray = [...splitStringIntoArray(text)];
		}, 30);
	}

	function splitStringIntoArray(inputString: string) {
		// Use a regular expression to remove opening and closing <p> tags
		// const newText = inputString.replace(/<\/?p>/g, '');
		// Split the string by spaces and return the resulting array
		const newArr = inputString.split(' ');

		return newArr.reduce((acc: RenderedText[], curr: string, i: number) => {
			acc.push({ id: i, text: curr });
			return acc;
		}, []);
	}

</script>

{#if $appStore.animatedMessageIds.includes(messageId)}
	{#if onlyText}
		{#each renderedTextArray as renderedText (renderedText.id)}
			<span in:fade={{delay: 180, duration: 800}}>
		    {@html renderedText.text}
		  </span>
		{/each}
	{:else}
		<slot/>
	{/if}
{:else}
	<slot/>
{/if}
